import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Icon from '../AppIcon';
import Button from './Button';
import { HashLink } from 'react-router-hash-link';

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const navigationItems = [
    { name: 'Mission Control', path: '/mission-control-hub-homepage', icon: 'Home' },
    { name: 'About Mission', path: '/about-mission', icon: 'User' },
    { name: 'Collaboration Station', path: '/collaboration-station', icon: 'Users' }
  ];

  const isActivePath = (path) => {
    return location?.pathname === path;
  };

  const toggleMenu = () => {
    setIsMenuOpen(!isMenuOpen);
  };

  const closeMenu = () => {
    setIsMenuOpen(false);
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-brand ${
      isScrolled 
        ? 'bg-background/95 backdrop-blur-sm shadow-brand border-b border-border' 
        : 'bg-background/80 backdrop-blur-xs'
    }`}>
      <div className="w-full">
        <div className="flex items-center justify-between h-16 px-4 sm:px-6 lg:px-8 bg-gradient-to-br from-deep-space via-slate-900 to-slate-800">
          {/* Logo Section */}
          <div className="flex items-center">
            <Link 
              to="/mission-control-hub-homepage" 
              className="flex items-center space-x-3 group transition-brand hover:opacity-80"
              onClick={closeMenu}
            >
              <div className="relative">
                <div className="w-10 h-10 bg-gradient-to-br from-rocket-fire to-electric-cyan rounded-lg flex items-center justify-center shadow-brand">
                  <Icon name="Rocket" size={24} color="white" strokeWidth={2.5} />
                </div>
                <div className="absolute -top-1 -right-1 w-3 h-3 bg-trust-green rounded-full animate-pulse-slow"></div>
              </div>
              <div className="hidden sm:block">
                <h1 className="font-headline text-xl text-deep-space text-sky-500">PortFolio</h1>
                <p className="text-xs text-text-secondary font-medium"> Ready To Develop</p>
              </div>
            </Link>
          </div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-1 ">
            {navigationItems?.map((item) => (
              <Link
                key={item?.path}
                to={item?.path}
                className={`flex items-center space-x-2 px-4 py-2 rounded-lg text-sm font-medium transition-brand 'bg-primary text-primary-foreground shadow-subtle text-white ' ${
                  isActivePath(item?.path)
                    ? 'bg-primary text-primary-foreground shadow-subtle text-white'
                    : 'text-text-primary hover:bg-brand-surface hover:text-deep-space text-white'
                }`}
              >
                <Icon name={item?.icon} size={18} strokeWidth={2} />
                <span>{item?.name}</span>
              </Link>
            ))}
          </nav>

          {/* CTA and Mobile Menu Button */}
          <div className="flex items-center space-x-4">
            {/* Desktop CTA */}
            <div className="hidden lg:block">
              <HashLink 
      smooth 
      to="/collaboration-station#contactform"
      style={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        
        color: "white",
        padding: "10px 16px",
        borderRadius: "9999px",
        textDecoration: "none"
      }}
    ><Button
                variant="default" 
                size="sm"
                className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta shadow-brand"
              >
                Let's Connect
              </Button></HashLink>
            </div>

            {/* Mobile Menu Button */}
            <button
              onClick={toggleMenu}
              className="md:hidden p-2 rounded-lg text-text-primary hover:bg-brand-surface transition-brand text-white"
              aria-label="Toggle menu"
            >
              <Icon name={isMenuOpen ? "X" : "Menu"} size={24} strokeWidth={2} />
            </button>
          </div>
        </div>

        {/* Mobile Navigation Menu */}
        <div className={`md:hidden transition-all duration-300 ease-brand ${
          isMenuOpen 
            ? 'max-h-96 opacity-100' :'max-h-0 opacity-0 overflow-hidden'
        }`}>
          <div className="px-4 py-4 bg-background border-t border-border">
            <nav className="space-y-2">
              {navigationItems?.map((item) => (
                <Link
                  key={item?.path}
                  to={item?.path}
                  onClick={closeMenu}
                  className={`flex items-center space-x-3 px-4 py-3 rounded-lg text-base font-medium transition-brand ${
                    isActivePath(item?.path)
                      ? 'bg-primary text-primary-foreground shadow-subtle'
                      : 'text-text-primary hover:bg-brand-surface hover:text-deep-space'
                  }`}
                >
                  <Icon name={item?.icon} size={20} strokeWidth={2} />
                  <span>{item?.name}</span>
                </Link>
              ))}
            </nav>
            
            {/* Mobile CTA */}
            <div className="mt-4 pt-4 border-t border-border">
              <Button 
                variant="default" 
                size="default"
                fullWidth
                className="bg-rocket-fire hover:bg-rocket-fire/90 text-white font-cta shadow-brand"
              >
                Let's Connect
              </Button>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};

export default Header;